<ws-modal-wrapper headerLabel="Change Due Dates"
                  [disableSave]="loading || !dueDate"
                  [disableCancel]="loading"
                  [loading]="loading"
                  (save)="save()"
                  (cancel)="cancel()">
    @if (!loading) {
        <div class="modal-body exclude-modal-styling">
            <label class="change-due-dates-date">
                <span>{{ dueDateText }}</span>
                <weissman-datetime [(inputDate)]="dueDate"
                                   [readOnly]="false"
                                   [dateOnly]="dateOnly">
                </weissman-datetime>
            </label>
        </div>
    }
</ws-modal-wrapper>
